export const EQUALS = "==";
export const LIKE = "=like=";



// WEBPACK FOOTER //
// ./src/components/common/GraphQL/GraphQLFilterTypes.js